import { useContext } from "react";
import { MessageThreadsContext } from "./MessageThreadsProvider";

export const useMessageThreads = (active?: boolean) => {
  const context = useContext(MessageThreadsContext);
  return {
    threads: context.threads.filter((thread) =>
      active != null ? thread.is_active === active : true,
    ),
    currentThread: context.currentThread,
  };
};
